import type { RoteiroType } from "../types";

/**
 * Maps a `RoteiroType` to its specialised `prompt_config_id` in the DB.
 *
 * Each format has its own seeded prompt (see migrations
 * `20260501030000_roteiros_format_agents_skeleton.sql` and follow-ups). The
 * monolith `roteiros.creation.system` is kept as a fallback for unknown
 * types — never the default, otherwise the type-specific agents are
 * bypassed and we lose all the specialised tuning.
 *
 * Bug history: client used to hardcode `roteiros.creation.system` regardless
 * of the user-selected format, sending every Anúncio/Stories/Reels request
 * through the generic monolith. See conversation 2026-05-13.
 */
export function routePromptId(type: RoteiroType): string {
  switch (type) {
    case "Reels":
      return "roteiros.reels.v1";
    case "Stories":
      return "roteiros.stories.v1";
    case "Anúncio":
      return "roteiros.anuncio.v1";
    default:
      return "roteiros.creation.system";
  }
}
